import axios from '@/libs/axios';
import { ErrorMessage } from '@/libs/Error';

export default class SlsClienteTipoPedidoClient {
  constructor() {
    this.api = axios;
    this.error = new ErrorMessage();
  }

  async getItems(queries = {}) {
    try {
      const { data } = await this.api.get('/cliente-tipo-pedido');
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar as ClienteTipoPedido');
    }
  }

  async index(queries = {}) {
    try {
      return await this.api.get('/cliente-tipo-pedido', { params: queries });
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar as ClienteTipoPedido');
    }
  }

  async store(data) {
    try {
      const response = await this.api.post('/cliente-tipo-pedido', data);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao criar as ClienteTipoPedido');
    }
  }

  async show(id) {
    try {
      const { data } = await this.api.get(`/cliente-tipo-pedido/${id}`);
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao buscar a ClienteTipoPedido');
    }
  }

  async update(data) {
    try {
      const { data: response } = await this.api.put('/cliente-tipo-pedido', data);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao atualizar a ClienteTipoPedido');
    }
  }

  async destroy(data) {
    try {
      const { data: response } = await this.api.post('/cliente-tipo-pedido/delete', data);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao deletar a ClienteTipoPedido');
    }
  }
}
